export const branchNameSubdomain = process.env.REACT_APP_BRANCH ? `${process.env.REACT_APP_BRANCH}.` : ''

export const branchNameSubfolder = process.env.REACT_APP_BRANCH ? `${process.env.REACT_APP_BRANCH}/` : ''
